import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

async function initApp() {
  const settingsResponse = await fetch('/settings.json')
  const settings = await settingsResponse.json()

  const baseAPI = axios.create({
    baseURL: settings.apiURL,
    withCredentials: true
  })

  baseAPI.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        router.push('/BlogAuthorLogin')
      }
      return Promise.reject(error)
    }
  )

  const app = createApp(App)
  app.use(router)

  // Global API instance
  app.config.globalProperties.$API = baseAPI

  // API endpoints (same pattern as FlyHigh)
  app.config.globalProperties.$LoginAdmin = 'adminauth/LoginAdmin'
  app.config.globalProperties.$CheckAdminSession = 'adminauth/CheckAdminSession'
  app.config.globalProperties.$LogoutAdmin = 'adminauth/LogoutAdmin'
  app.config.globalProperties.$UploadBlogArticleHtml = 'insert/UploadBlogArticleHtml'
  app.config.globalProperties.$ListAllBlog = 'read/ListAllBlog'
  app.config.globalProperties.$ListPublishBlog = 'read/ListPublishBlog'
  app.config.globalProperties.$DeleteBlogPost = 'delete/DeleteBlogPost'

  app.mount('#app')
}

initApp()
